import React from "react";
import { Listbox, Transition } from "@headlessui/react";
import { FaCheck, FaSort } from "react-icons/fa";

export const Select = ({
	options,
	selectedOption,
	handleChange,
	isReadOnly,
	bg,
	containerStyles,
}) => {
	const disabled = isReadOnly ?? false;
	const bgClass = disabled ? "bg-white bg-opacity-30" : bg ? bg : "bg-white";

	return (
		<Listbox
			as="div"
			value={selectedOption && selectedOption.id}
			onChange={(event) => {
				handleChange(event);
			}}
			disabled={disabled}
		>
			{({ open }) => (
				<>
					<Listbox.Button
						className={`formField cursor-default ${containerStyles} relative w-full ${bgClass} text-left`}
					>
						<span className="text-black block text-ellipsis truncate">
							{selectedOption && selectedOption.label}
						</span>
						<span className="absolute inset-y-0 right-0 flex items-center pr-1 ml-3 pointer-events-none">
							<FaSort
								className={`text-gray-500 ${
									disabled ? "text-opacity-30" : null
								}`}
							/>
						</span>
					</Listbox.Button>
					<Transition
						className={"fixed inset-0 bg-trans-black z-30 h-full"}
						show={open}
						leave="transition duration-100 ease-in"
						leaveFrom="transform opacity-100"
						leaveTo="transform opacity-0"
					>
						<Listbox.Options
							as="div"
							static
							className="fixed inset-0 m-auto max-w-picker max-h-40 bg-white rounded-md shadow-md overflow-auto text-base rounded-md ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
						>
							{options.map((option) => {
								return (
									<Listbox.Option key={option.id} value={option.id} as="div">
										{({ active, selected }) => {
											return (
												<div
													className={`${
														active ? "text-white bg-app-charcoal" : "text-black"
													} cursor-default select-none relative py-2 pl-3 pr-9 border-b border-gray-100`}
												>
													<div className="flex items-center">
														<span
															className={`${
																selected ? "font-semibold" : "font-normal"
															} flex items-center block break-normal`}
														>
															{option.label}
														</span>
														{selected && (
															<span
																className={`${
																	active ? "text-white" : "text-black"
																} absolute inset-y-0 right-0 flex items-center mr-3 pl-1.5`}
															>
																<FaCheck
																	className={`${
																		active ? "text-white" : "text-black"
																	}`}
																/>
															</span>
														)}
													</div>
												</div>
											);
										}}
									</Listbox.Option>
								);
							})}
						</Listbox.Options>
					</Transition>
				</>
			)}
		</Listbox>
	);
};
